import Vue from 'vue'
import Router from 'vue-router'
import TyphoonTW from '@/components/typhoon_tw/TyphoonTW'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: TyphoonTW
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js